import ApiService from './ApiService'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/admin-sessions',
        method: 'post',
        data,
    })
}

export async function apiSignOut() {
    return ApiService.fetchData({
        url: '/admin-sessions',
        method: 'delete',
    })
}

export async function apiRefreshSession() {
    return ApiService.fetchData({
        url: '/admin-sessions',
        method: 'put',
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/admin-verifications/password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/admin-verifications/password',
        method: 'put',
        data,
    })
}

export async function resendMailCreateAdminPassword(data) {
    return ApiService.fetchData({
        url: '/admins/set-password',
        method: 'post',
        data,
    })
}

export async function createAdminPassword(data) {
    return ApiService.fetchData({
        url: '/admins/set-password',
        method: 'put',
        data,
    })
}
